import React from 'react';
import Layout from '../components/layout/Layout';
import Button from '../components/ui/Button';

const capabilities = [
  'Execution infrastructure for expanding operations',
  'Financial structure and treasury management',
  'Supply chain, logistics, and export coordination',
  'Process automation and systems integration',
  'Vendor, supplier, and contractor coordination',
  'Compliance, reporting, and institutional readiness',
];

const exclusions = [
  'We do not provide consulting or advisory services',
  'We do not work with pre-revenue companies or pitch-deck operators',
  'We do not build apps, websites, or software products',
  'We do not manage marketing, brand, or content',
  'We do not offer hourly or retainer-based arrangements',
  'We do not negotiate control structures post-engagement',
];

const steps = [
  {
    number: '01',
    title: 'Brief Submission',
    description: 'Submit a structured brief about your existing operation. Unqualified submissions are not reviewed.',
  },
  {
    number: '02',
    title: 'Assessment',
    description: 'We evaluate operational state, owner disposition, and system fit. Most briefs are declined.',
  },
  {
    number: '03',
    title: 'Terms',
    description: 'If accepted, terms are issued. They are non-negotiable. Engagement begins upon signature.',
  },
  {
    number: '04',
    title: 'Operation',
    description: 'We deploy systems. We run operations. Owners retain vision; we handle execution.',
  },
];

export function Home() {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="section border-b border-border">
        <div className="container-narrow">
          <div className="space-y-8">
            <h1 className="text-display-sm md:text-display text-balance">
              Bliu Interactive operates the execution layer for revenue-generating businesses.
            </h1>
            <p className="text-body-lg text-muted">
              We do not advise. We run.
            </p>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section className="section border-b border-border">
        <div className="container-narrow">
          <div className="space-y-8">
            <h2 className="text-heading-sm text-muted uppercase tracking-wider">
              Operational Capabilities
            </h2>
            <ul className="space-y-4">
              {capabilities.map((item, index) => (
                <li key={index} className="flex items-start gap-4">
                  <span className="text-muted text-small mt-1">—</span>
                  <span className="text-body-lg">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* What We Don't Do */}
      <section className="section border-b border-border">
        <div className="container-narrow">
          <div className="space-y-8">
            <h2 className="text-heading-sm text-muted uppercase tracking-wider">
              Explicit Exclusions
            </h2>
            <ul className="space-y-4">
              {exclusions.map((item, index) => (
                <li key={index} className="flex items-start gap-4">
                  <span className="text-muted text-small mt-1">×</span>
                  <span className="text-body text-subtle">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* How Engagement Works */}
      <section className="section border-b border-border">
        <div className="container-narrow">
          <div className="space-y-12">
            <h2 className="text-heading-sm text-muted uppercase tracking-wider">
              Engagement Model
            </h2>
            <div className="space-y-10">
              {steps.map((step) => (
                <div key={step.number} className="flex gap-6">
                  <span className="text-caption text-muted font-mono shrink-0 pt-1">
                    {step.number}
                  </span>
                  <div className="space-y-2">
                    <h3 className="text-subheading">{step.title}</h3>
                    <p className="text-body text-subtle">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Access Gate */}
      <section className="section">
        <div className="container-narrow">
          <div className="space-y-6 text-center">
            <Button to="/brief" size="lg">
              Submit a Brief
            </Button>
            <p className="text-small text-muted">
              Only for operators prepared to surrender operational control.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Home;
